export const getQueryKey = (
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  endpoint: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: Record<string, any>
) => [[method, endpoint, data]];
